import DefaultValidation from '@/services/validations/DefaultValidation';
import * as Util from '@/functions/Util';

export default class SaldoProdutoValidation extends DefaultValidation {
	validate(model, empresaSelected, refs) {
		let validated = true;

		if (empresaSelected==null) {
			refs.empresaSelect.focusedOut = true;
			validated = false;
		}
		if (Util.isNull(model.saldo)) {
			refs.saldoInput.focusedOut = true;
			validated = false;
		}
		if (Util.isNull(model.saldominimo)) {
			refs.saldominimoInput.focusedOut = true;
			validated = false;
		}

		return validated;
	}

	validateRemessa(model, empresaSelected, refs) {
		let validated = true;

		if (empresaSelected==null) {
			refs.empresaSelect.focusedOut = true;
			validated = false;
		}
		if (Util.isNull(model.saldo)) {
			refs.saldoInput.focusedOut = true;
			validated = false;
		}

		return validated;
	}

	validateGrade(model, refs) {
		let validated = true;

		if (Util.isNull(model.saldo)) {
			refs.saldoInput.focusedOut = true;
			validated = false;
		}

		return validated;
	}
}